import React from "react";
import css from "./Config.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Identifier from "./Identifier";
import Spinner from "../../Spinner";
import { useSession } from "../../../hooks/session";
import pg from "./pg3.png";
import { useChangePerspective } from "../../../hooks/perspective";

const Config = ({ sessionId, layoutFns }) => {
  return (
    <div className={css.containerRelativeLayout}>
      <div className={css.layout}>
        <Identifier sessionId={sessionId} layoutFns={layoutFns} />
        <NetworkTypes layoutFns={layoutFns} sessionId={sessionId} />
        <div className={css.pgBox}>
          <div style={{ placeSelf: "center" }}>
            {" "}
            Power Graph Encoding{" "}
            <a
              style={{ placeSelf: "center end" }}
              href={"https://doi.org/10.1371/journal.pcbi.1000108"}
            >
              {" "}
              Royer et al., 2008
            </a>
          </div>
          <img
            className={css.pgBoxImg}
            src={pg}
            height={"100%"}
            width={"95%"}
            alt={"Power Graph encoding motifs"}
          />
        </div>
      </div>
    </div>
  );
};

export default Config;

const NetworkTypes = ({ sessionId, layoutFns }) => {
  const { data, isLoading } = useSession(sessionId);
  const { changePerspective } = useChangePerspective();
  if (isLoading) return <Spinner />;

  return (
    <div className={css.layoutUtilities}>
      <h2 className={css.layoutTypeH2}>Layout</h2>
      <div className={css.chooseLayoutDiv}>
        <select
          className={css.selectLayout}
          value={isLoading ? "" : data.network_type}
          onChange={(event) => {
            const userColor = getUserColor(
              data.userColorImported,
              layoutFns.getCyElements()
            );

            changePerspective(
              data.species,
              data.database,
              data.nativeId,
              event.target.value,
              data.protein_type,
              userColor
            );
          }}
        >
          {data.allowed_network_types.map((choice) => (
            <option key={choice.value} value={choice.value}>
              {choice.name}
            </option>
          ))}
        </select>
        <FontAwesomeIcon
          icon="angle-down"
          size="lg"
          className={css.arrowDown}
        />
      </div>
      <button
        className={css.enhancesLayout}
        onClick={() => {
          data.network_type === "simple"
            ? layoutFns.enhancesLayoutSimple()
            : layoutFns.enhancesLayoutCompound();
        }}
      >
        Enhances Layout
      </button>
      <button
        className={css.resetLayout}
        onClick={() => {
          data.network_type === "simple"
            ? layoutFns.resetLayoutSimple()
            : layoutFns.resetLayoutCompound();
        }}
      >
        Reset Layout
      </button>
      <button className={css.resetZoom} onClick={layoutFns.resetZoom}>
        Reset Zoom
      </button>
      <button className={css.removeOverlap} onClick={layoutFns.overlapRemoval}>
        Remove Overlap
      </button>
    </div>
  );
};

const getUserColor = (userColorImported, cyElements) => {
  let flag = userColorImported.flag
  let payload = {}  
  let userColor = {};

  if (flag) {
    for (let i = 0; i < cyElements.length; i++) {
      if (cyElements[i].group === "nodes") {
        let float_value;
        if ("User Numeric Value" in cyElements[i].data) {
          float_value = parseFloat(cyElements[i].data["User Numeric Value"]);
        } else {
          float_value = false;
        }

        userColor[cyElements[i].data.label] = [cyElements[i].data.color, float_value];
      }
    }

    payload["case_sensitive"] = userColorImported.case_sensitive
    payload["color_list"] = userColor
    payload["header_label"] = userColorImported.header_label
  }

  return payload;
};
